import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "scrollable-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "card" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "zamg-text-headline" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "fill-height d-flex flex-column" }, {
        default: _withCtx(() => [
          (_ctx.showSearch)
            ? (_openBlock(), _createBlock(_component_v_text_field, {
                key: 0,
                modelValue: _ctx.search,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                class: "flex-none mb-4",
                "prepend-icon": "mdi-magnify",
                "data-testid": "parameter-search",
                label: _ctx.t('search') + '...',
                "single-line": "",
                "hide-details": "",
                variant: "outlined",
                density: "compact",
                clearable: ""
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_data_table, {
              modelValue: _ctx.localSelected,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localSelected) = $event)),
                _ctx.emitSelected
              ],
              class: "mt-4 param-table",
              "item-key": "name",
              "items-per-page": "-1",
              "hide-default-footer": "",
              items: _ctx.items,
              headers: _ctx.headers,
              search: _ctx.search,
              "return-object": true,
              "loading-text": _ctx.t('loading'),
              "no-data-text": _ctx.t('no_data_available'),
              "checkbox-color": "primary",
              "show-select": _ctx.showSelect
            }, null, 8, ["modelValue", "items", "headers", "search", "loading-text", "no-data-text", "show-select", "onUpdate:modelValue"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}